import React from 'react';
import logComponent from '../../common/logComponent';
import './FixedHeader.css';

export default function FixedHeader({ children }) {
  if (logComponent('FixedHeader')) { console.debug('FixedHeader rendered'); }

  return (
    <div className="Fixed-Header">
      <header className="Fixed-Header__content">
        {children}
      </header>
      <div className="Fixed-Header__space-eater">
        {children}
      </div>
    </div>
  )
}
